import React from 'react';
import { Card, CardContent, Grid, Skeleton, Typography } from '@mui/material';
import type { UsageSummary } from '../../types/usage';
import { formatTokens, formatUsd } from '../../services/usage.service';

const Tile: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Grid item xs={6} md={3}>
    <Card variant="outlined"><CardContent>
      <Typography variant="overline" color="text.secondary">{label}</Typography>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>{value}</Typography>
    </CardContent></Card>
  </Grid>
);

export const SummaryTiles: React.FC<{ summary: UsageSummary | undefined; isLoading: boolean; isError?: boolean }> = ({ summary, isLoading, isError }) => {
  if (!isLoading && isError) {
    return <Typography color="error">Couldn't load usage summary. Try refreshing.</Typography>;
  }
  if (isLoading || !summary) return <Skeleton variant="rectangular" height={96} />;
  return (
    <Grid container spacing={2}>
      <Tile label="Tokens" value={formatTokens(summary.tokens.total)} />
      <Tile label="Cost" value={formatUsd(summary.cost_usd)} />
      <Tile label="Prompts" value={String(summary.prompts)} />
      <Tile label="Avg tokens / prompt" value={formatTokens(summary.avg_tokens_per_prompt)} />
    </Grid>
  );
};

export default SummaryTiles;
